/**
 * referenceDataMappers — ScheduleDraft 引用数据到表单选项的映射工具层。
 *
 * 本模块把飞机、机场与航路 master data 转换为 Feature 内统一消费的 option
 * 形状。hooks 与 service 共享这些 mapper，确保引用数据 React Query 统一化后
 * 不在组件里重复拼接 label/value。
 *
 * 设计文档 → docs/10_core_contracts/12_api_v3_frontend_boundary.md
 * 骨架关联 → services/scheduleDraftReferenceDataService.js (引用数据 API), hooks/useScheduleDraftFlightFormOptions.js (航班表单选项), hooks/useScheduleDraftCreateFormOptions.js (创建表单选项)
 */

/**
 * 将飞机主数据映射为 Select option。
 * @param {Object} aircraft - 飞机主数据对象。
 * @returns {{label: string, value: string}} 表单选择项。
 */
export function mapAircraftOption(aircraft) {
    return {
        label: `${aircraft.registration}${aircraft.aircraft_type ? ` (${aircraft.aircraft_type})` : ""}`,
        value: aircraft.registration,
    };
}

/**
 * 将机场主数据映射为 Select option。
 * @param {Object} airport - 机场主数据对象。
 * @returns {{label: string, value: string}} 表单选择项。
 */
export function mapAirportOption(airport) {
    const code = airport.iata_code || airport.code || airport.airport_code;
    const name = airport.name || airport.airport_name || "Unknown";

    return {
        label: `${code} - ${name}`,
        value: code,
    };
}

/**
 * 将航路主数据映射为航路选择 option，并保留原始 route。
 * @param {Object} route - 航路主数据对象。
 * @returns {{label: string, value: *, route: Object}} 航路选择项。
 */
export function mapFlightRouteOption(route) {
    const blockTimeMinutes = route.block_time_minutes;
    const blockTimeLabel = blockTimeMinutes ? `${Math.floor(blockTimeMinutes / 60)}h${String(blockTimeMinutes % 60).padStart(2, "0")}` : "BH N/A";

    return {
        label: `${route.route_name || `${route.departure_airport || "--"}-${route.arrival_airport || "--"}`} (${blockTimeLabel})${route.is_default ? " [默认]" : ""}`,
        value: route.id,
        route,
    };
}
